module.exports = __webpack_public_path__ + "img/xt_03.bfd52a2c.png";